import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Terms_Conditions = () => {
    return (
        <div className="container py-5">
            <div className="card shadow-lg border-0 rounded-4">
                <div className="card-body p-4 p-md-5">
                    {/* Header */}
                    <div className="border-bottom border-dark border-2 pb-4 mb-4">
                        <h1 className="display-5 fw-bold text-dark">
                            CERA STARPLUMBER
                        </h1>
                        <h2 className="h4 fw-semibold text-dark mt-1">
                            LOYALTY PROGRAMME
                        </h2>
                        <div className="d-flex flex-wrap gap-4 mt-2 text-dark small">
                            <span>
                                <strong>Effective Date:</strong> June 2026
                            </span>
                            <span>
                                <strong>Application:</strong> CERA StarPlumber
                            </span>
                            <span>
                                <strong>Sales Portal:</strong>{" "}
                                <a
                                    href="https://cerastarplumber.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-dark text-decoration-underline"
                                >
                                    cerastarplumber.com
                                </a>
                            </span>
                            <span>
                                <strong>Issued By:</strong> CERA Sanitaryware Limited
                            </span>
                        </div>
                    </div>

                    {/* A. GENERAL TERMS */}
                    <Section title="A. GENERAL TERMS">
                        <li>
                            The CERA StarPlumber Loyalty Programme ("Programme") is a
                            voluntary loyalty and rewards initiative of CERA Sanitaryware
                            Limited for eligible plumbers across India.
                        </li>
                        <li>
                            By registering, accessing, or participating in the Programme, the
                            participant agrees to be bound by these Terms &amp; Conditions.
                        </li>
                        <li>
                            Participation in the Programme is voluntary and does not create
                            any employment relationship, agency relationship, franchise,
                            partnership, joint venture, contractual obligation, or legal
                            entitlement between the participant and CERA.
                        </li>
                        <li>
                            CERA reserves the right to amend, modify, suspend, withdraw,
                            discontinue, or terminate the Programme at any time without prior
                            notice.
                        </li>
                        <li>
                            The decision of CERA regarding eligibility, verification, reward
                            allocation, redemption, disputes, and Programme administration
                            shall be final and binding.
                        </li>
                        <li>
                            CERA reserves the right to suspend account access, Star accrual,
                            redemption, and participation during investigation of suspected
                            fraud or misuse.
                        </li>
                    </Section>

                    {/* B. ELIGIBILITY */}
                    <Section title="B. ELIGIBILITY">
                        <li>
                            The Programme is open only to practising plumbers residing in
                            India who are above 18 years of age.
                        </li>
                        <li>
                            Participants must possess a valid Aadhaar Card and valid KYC
                            documents.
                        </li>
                        <li>
                            Only plumbers purchasing eligible products/SKUs from
                            CERA-authorized dealers or retailers are eligible to participate.
                        </li>
                        <li>
                            Registration shall be subject to validation and approval by the
                            CERA Sales Team.
                        </li>
                        <li>
                            Employees, officers, agents, contractors, distributors, programme
                            administrators, technology partners, and their immediate family
                            members are not eligible to participate unless specifically
                            approved by CERA.
                        </li>
                        <li>
                            A participant may be enrolled in only one CERA loyalty programme
                            at a time. CERA reserves the right to migrate or reclassify
                            participants between programmes based on eligibility criteria and
                            business requirements.
                        </li>
                        <li>
                            This Programme cannot be clubbed with any other scheme,
                            incentive, promotion, or offer unless specifically approved in
                            writing by CERA.
                        </li>
                    </Section>

                    {/* C. REGISTRATION PROCESS */}
                    <Section title="C. REGISTRATION PROCESS">
                        <li>
                            Registration shall be completed through the CERA StarPlumber
                            Mobile Application.
                        </li>
                        <li>
                            During registration, the participant shall provide:
                            <ul className="mt-2 ms-4">
                                <li>Name</li>
                                <li>Mobile Number</li>
                                <li>ID Type</li>
                                <li>ID Number</li>
                                <li>Front Image of ID</li>
                                <li>Back Image of ID</li>
                                <li>Email Address (Optional)</li>
                                <li>Address Details</li>
                                <li>State</li>
                                <li>District</li>
                                <li>City</li>
                                <li>PIN Code</li>
                            </ul>
                        </li>
                        <li>
                            Prior to registration, the participant must expressly accept the
                            Terms &amp; Conditions and Privacy Policy.
                        </li>
                        <li>
                            An OTP shall be sent to the registered mobile number for
                            verification.
                        </li>
                        <li>
                            Registration shall be deemed complete only after successful OTP
                            validation.
                        </li>
                        <li>
                            Only one mobile number may be registered per participant.
                        </li>
                        <li>
                            CERA reserves the right to seek additional documents and
                            information for verification purposes.
                        </li>
                    </Section>

                    {/* D. APPROVAL WORKFLOW */}
                    <Section title="D. APPROVAL WORKFLOW">
                        <li>
                            Self-Registered Plumbers:
                            <ul className="mt-2 ms-4">
                                <li>Registration Verification</li>
                                <li>Sales Team Approval</li>
                                <li>Account Activation</li>
                            </ul>
                        </li>
                        <li>
                            Sales Team Registered Plumbers:
                            <br />
                            Accounts created directly by the Sales Team shall be automatically
                            approved.
                        </li>
                        <li>
                            Image Verification:
                            <br />
                            The Sales Team shall capture and verify a live photograph of the
                            plumber before approving image verification.
                        </li>
                        <li>
                            CERA may reject, suspend, or terminate any registration where
                            information is inaccurate, incomplete, misleading, or fraudulent.
                        </li>
                    </Section>

                    {/* E. EARNING OF STARS */}
                    <Section title="E. EARNING OF STARS">
                        <li>
                            Upon successful account approval, the participant shall receive
                            50 Stars as a Welcome Bonus.
                        </li>
                        <li>
                            Thereafter, Stars may be earned by scanning valid QR Codes
                            through the application.
                        </li>
                        <li>
                            Only eligible CERA products purchased from authorized dealers and
                            retailers shall qualify for earning Stars.
                        </li>
                        <li>
                            No Stars shall be awarded for:
                            <ul className="mt-2 ms-4">
                                <li>Duplicate QR scans</li>
                                <li>Invalid QR scans</li>
                                <li>Manipulated QR scans</li>
                                <li>Fraudulent scans</li>
                                <li>Damaged QR codes</li>
                                <li>Suspicious transactions</li>
                            </ul>
                        </li>
                        <li>
                            All Stars shall be awarded as per the reward matrix prescribed by
                            CERA from time to time.
                        </li>
                        <li>
                            One (1) Star shall be equivalent to INR 1 unless revised by CERA.
                        </li>
                        <li>
                            Stars are non-transferable and cannot be assigned, gifted,
                            exchanged, or sold.
                        </li>
                        <li>
                            Stars shall not be treated as cash, salary, commission,
                            compensation, or legal entitlement.
                        </li>
                    </Section>

                    {/* F. REDEMPTION OF STARS */}
                    <Section title="F. REDEMPTION OF STARS">
                        <li>
                            Redemption may be processed through:
                            <ul className="mt-2 ms-4">
                                <li>UPI Transfer</li>
                                <li>Bank Transfer</li>
                                <li>Paytm Wallet (where applicable)</li>
                                <li>E-Vouchers</li>
                                <li>Gift Vouchers</li>
                                <li>Merchandise</li>
                                <li>Physical Products available in the reward catalogue</li>
                            </ul>
                        </li>
                        <li>
                            For first redemption, the participant must:
                            <ul className="mt-2 ms-4">
                                <li>Have a minimum balance of 500 Stars.</li>
                                <li>Complete KYC verification.</li>
                                <li>Complete Image Verification.</li>
                                <li>Upload a passbook or cancelled-cheque image.</li>
                            </ul>
                        </li>
                        <li>
                            Redemption Process:
                            <ul className="mt-2 ms-4">
                                <li>Open Redeem Stars section.</li>
                                <li>Select UPI Transfer or Bank Transfer.</li>
                                <li>Enter number of Stars to redeem.</li>
                                <li>Generate OTP.</li>
                                <li>Enter OTP.</li>
                                <li>Submit redemption request.</li>
                            </ul>
                        </li>
                        <li>
                            Redemption requests once processed cannot be cancelled or
                            reversed.
                        </li>
                        <li>
                            Reward availability shall be subject to stock availability and
                            operational feasibility.
                        </li>
                        <li>
                            CERA shall not be responsible for quality, warranty,
                            merchantability, after-sales service, replacement, installation,
                            delivery, or performance of third-party rewards.
                        </li>
                    </Section>

                    {/* G. PAN, AADHAAR & TAX COMPLIANCE */}
                    <Section title="G. PAN, AADHAAR &amp; TAX COMPLIANCE">
                        <li>
                            Participants expressly consent to providing Aadhaar, PAN, bank
                            account details, and KYC information.
                        </li>
                        <li>
                            Such information may be collected, verified, processed, stored,
                            and used for:
                            <ul className="mt-2 ms-4">
                                <li>Identity Verification</li>
                                <li>KYC Compliance</li>
                                <li>Loyalty Programme Administration</li>
                                <li>Reward Processing</li>
                                <li>TDS Deduction</li>
                                <li>Income Tax Reporting</li>
                                <li>Fraud Prevention</li>
                                <li>Audit Requirements</li>
                                <li>Regulatory Compliance</li>
                            </ul>
                        </li>
                        <li>
                            Wherever applicable under prevailing tax laws, TDS may be
                            deducted before processing redemption payouts.
                        </li>
                        <li>
                            Participants confirm that all PAN, Aadhaar, KYC, and banking
                            information provided is accurate and belongs to them.
                        </li>
                    </Section>

                    {/* H. COMMUNICATION CONSENT */}
                    <Section title="H. COMMUNICATION CONSENT">
                        <li>
                            By registering under the Programme, participants expressly
                            consent to receive communications through:
                            <ul className="mt-2 ms-4">
                                <li>Phone Calls</li>
                                <li>SMS</li>
                                <li>WhatsApp Messages</li>
                                <li>Emails</li>
                                <li>Mobile Application Notifications</li>
                            </ul>
                        </li>
                        <li>
                            Communications may include:
                            <ul className="mt-2 ms-4">
                                <li>OTPs</li>
                                <li>Registration Updates</li>
                                <li>Verification Requests</li>
                                <li>KYC Notifications</li>
                                <li>Point Credit Notifications</li>
                                <li>Redemption Confirmations</li>
                                <li>Promotional Campaigns</li>
                                <li>Programme Announcements</li>
                                <li>Surveys</li>
                                <li>Customer Support Communications</li>
                            </ul>
                        </li>
                        <li>
                            Transactional communications necessary for Programme
                            administration may continue irrespective of promotional
                            communication preferences.
                        </li>
                    </Section>

                    {/* I. DATA PRIVACY & DPDP ACT, 2023 */}
                    <Section title="I. DATA PRIVACY &amp; DPDP ACT, 2023">
                        <li>
                            CERA acts as the Data Fiduciary under the Digital Personal Data
                            Protection Act, 2023.
                        </li>
                        <li>
                            By participating, participants provide free, informed, specific,
                            unconditional, and unambiguous consent for processing of personal
                            data.
                        </li>
                        <li>
                            Data collected may include:
                            <ul className="mt-2 ms-4">
                                <li>Name</li>
                                <li>Mobile Number</li>
                                <li>Email Address</li>
                                <li>Address</li>
                                <li>Aadhaar Details</li>
                                <li>PAN Details</li>
                                <li>Bank Account Details</li>
                                <li>UPI ID</li>
                                <li>KYC Documents</li>
                                <li>Photographs</li>
                                <li>Device Information</li>
                                <li>QR Scan History</li>
                                <li>Transaction History</li>
                                <li>Communication Records</li>
                            </ul>
                        </li>
                        <li>
                            Data may be used for:
                            <ul className="mt-2 ms-4">
                                <li>Registration</li>
                                <li>Verification</li>
                                <li>Loyalty Programme Administration</li>
                                <li>Reward Management</li>
                                <li>Redemption Processing</li>
                                <li>Tax Compliance</li>
                                <li>Fraud Prevention</li>
                                <li>Analytics</li>
                                <li>Customer Support</li>
                                <li>Legal &amp; Regulatory Obligations</li>
                            </ul>
                        </li>
                        <li>
                            Data may be shared with authorized technology partners, payment
                            partners, verification agencies, auditors, logistics providers,
                            and government authorities where required by law.
                        </li>
                        <li>
                            Participants shall have rights available under the DPDP Act, 2023
                            including access, correction, erasure, grievance redressal,
                            nomination, and consent withdrawal.
                        </li>
                        <li>
                            Withdrawal of consent may result in suspension or termination of
                            participation in the Programme.
                        </li>
                        <li>
                            The Privacy Notice governing collection, processing, storage,
                            sharing, retention, and usage of personal data shall be made
                            available through the Program website, mobile application, or
                            other official communication channels.
                        </li>
                        <li>
                            Participants may withdraw consent through the mobile application,
                            website, customer support channel, Grievance Officer, or such
                            other mechanism as may be prescribed by CERA. Withdrawal of
                            consent may impact participation in the Program.
                        </li>
                        <li>
                            Personal data shall be retained only for the period necessary for
                            Program administration, legal compliance, audit requirements, tax
                            obligations, dispute resolution, and regulatory requirements.
                            Upon expiry of such period, personal data shall be deleted or
                            anonymized in accordance with applicable law.
                        </li>
                        <li>
                            Participants may contact the designated Grievance Officer for
                            privacy-related concerns, correction requests, consent withdrawal
                            requests, and grievance redressal.
                        </li>
                    </Section>

                    {/* J. FRAUD, MISUSE & NEGATIVE BALANCE */}
                    <Section title="J. FRAUD, MISUSE &amp; NEGATIVE BALANCE">
                        <li>
                            Any fraudulent activity, duplicate registrations, false
                            documentation, QR manipulation, or misuse of the Programme shall
                            result in immediate suspension or termination.
                        </li>
                        <li>
                            All Stars accumulated under fraudulent circumstances may be
                            forfeited.
                        </li>
                        <li>
                            If Stars are inadvertently credited due to technical issues,
                            duplicate transactions, manual errors, backend discrepancies,
                            reporting mismatches, or system glitches, CERA reserves the right
                            to reverse such Stars.
                        </li>
                        <li>Such adjustments may result in a negative Star balance.</li>
                        <li>
                            Future Stars earned may be adjusted against such negative balance
                            until recovery is completed.
                        </li>
                        <li>
                            Redemption shall remain restricted until the account is
                            regularized.
                        </li>
                    </Section>

                    {/* K. TAMIL NADU COMPLIANCE */}
                    <Section title="K. TAMIL NADU COMPLIANCE">
                        <li>
                            Any reward, incentive, or benefit falling within the scope of The
                            Lotteries (Regulation) Act, 1998 shall not be available to
                            participants located in the State of Tamil Nadu to the extent
                            prohibited by law.
                        </li>
                    </Section>

                    {/* L. LIMITATION OF LIABILITY */}
                    <Section title="L. LIMITATION OF LIABILITY">
                        <li>
                            CERA shall not be liable for any direct, indirect, incidental,
                            consequential, special, or punitive damages arising from
                            participation in the Programme.
                        </li>
                        <li>
                            CERA shall not be liable for delays, technical failures, internet
                            outages, server issues, force majeure events, governmental
                            restrictions, pandemics, labour disruptions, or any circumstances
                            beyond its reasonable control.
                        </li>
                        <li>
                            CERA shall not be responsible for non-availability of rewards due
                            to inventory shortages, supplier issues, logistics disruptions,
                            climatic conditions, labour unrest, insolvency, business
                            exigencies, or technical issues.
                        </li>
                    </Section>

                    {/* M. DISPUTE RESOLUTION & JURISDICTION */}
                    <Section title="M. DISPUTE RESOLUTION &amp; JURISDICTION">
                        <li>
                            Any dispute, controversy, or conflict relating to Stars, rewards,
                            redemption, verification, or Programme participation shall first
                            be referred to CERA.
                        </li>
                        <li>
                            CERA may appoint an internal committee to review and resolve such
                            disputes.
                        </li>
                        <li>
                            The decision of CERA and/or its authorized committee shall be
                            final and binding.
                        </li>
                        <li>These Terms shall be governed by the laws of India.</li>
                        <li>
                            All disputes shall be subject to the exclusive jurisdiction of
                            the courts at Ahmedabad, Gujarat.
                        </li>
                        <li>
                            Any dispute relating to QR scan failure, scan rejection,
                            duplicate scan detection, or Star allocation must be reported
                            within fifteen (15) days from the date of transaction.
                        </li>
                        <li>
                            CERA shall not be responsible for payout failures arising from
                            incorrect UPI IDs, incorrect bank account details, frozen
                            accounts, account restrictions, or participant errors.
                        </li>
                    </Section>

                    {/* DECLARATION */}
                    <div className="mt-5 p-4 bg-light border rounded-4">
                        <h3 className="h4 fw-bold text-dark border-start border-dark border-4 ps-3 mb-3">
                            DECLARATION
                        </h3>
                        <p className="fw-semibold mb-3">
                            I hereby confirm that:
                        </p>
                        <ul className="list-unstyled">
                            <li className="mb-2">✓ I am above 18 years of age.</li>
                            <li className="mb-2">
                                ✓ I am a practising plumber eligible to participate in the
                                Programme.
                            </li>
                            <li className="mb-2">
                                ✓ All information and documents submitted by me are true,
                                accurate, and complete.
                            </li>
                            <li className="mb-2">
                                ✓ I voluntarily consent to the collection, storage, processing,
                                and use of my personal information by CERA.
                            </li>
                            <li className="mb-2">
                                ✓ I authorize CERA to use my Aadhaar, PAN, KYC, banking
                                details, and related information for verification, reward
                                processing, TDS deduction, audit requirements, and statutory
                                compliance.
                            </li>
                            <li className="mb-2">
                                ✓ I consent to receive communications through Call, SMS,
                                WhatsApp, Email, and Mobile Application notifications.
                            </li>
                        </ul>
                        <p className="mt-3 text-dark small">
                            Participants may opt out of promotional communications in
                            accordance with applicable law. Transactional communications
                            necessary for Program administration may continue irrespective of
                            communication preferences.
                        </p>
                        <p className="mt-2 fw-semibold">
                            I have read, understood, and accepted these Terms &amp; Conditions
                            and Privacy Notice.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Helper Component for Sections
const Section = ({ title, children }) => {
    return (
        <div className="mt-4">
            <h3 className="h4 fw-bold text-dark border-start border-dark border-4 ps-3 mb-3">
                {title}
            </h3>
            <ul className="list-unstyled ps-4">
                {React.Children.map(children, (child) => (
                    <li className="mb-2 position-relative ps-3">
                        <span className="position-absolute start-0 text-dark">•</span>
                        {child}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Terms_Conditions;
